export default {
  formTitles: {
    create: 'Create Site',
    edit: 'Edit Site',
  },
  sections: {
    basicDetails: {
      title: 'Basic details',
      subtitle: '',
    },
    contactDetails: {
      title: 'Contact details',
      subtitle: '',
    },
    locationDetails: {
      title: 'Location details',
      subtitle: '',
    },
    contractType: {
      title: 'Contract type',
      subtitle: '',
    },
    fundingDetails: {
      title: 'Funding details',
      subtitle: '',
    },
  },
  subHeaders: {
    clientType: 'Client type',
    companyDetails: 'Company details',
    clientDetails: 'Client details',
    siteAddress: 'Site address',
    deliveryAddress: 'Delivery address',
    contractType: 'Contract type',
    targetProfitMargin: {
      label: 'Target profit margin',
      description:
        'Your profit margin will be the difference between your site contract budget and your BOQ value.',
    },
    fundingSources: 'Funding sources',
    bankFunding: 'Bank funding',
    selfFunding: 'Self funding',
    totalFunding: 'Total',
    defaultMarkup: {
      label: 'Default contract markup',
      description:
        'Your markup percentage will be added to the selling price of all goods and services added to your BOQ. This can be toggled on and off to view in the BOQ.',
    },
  },
  fields: {
    project: 'Project',
    noProjectsFound: 'No projects found',
    siteName: 'Site name',
    siteShortCode: 'Site short code',
    siteShortCodeInfo:
      'A {min} or {max} character code used on order and payment IDs. Eg. OR010125-{code}-423',
    siteShortCodeExists: 'This short code is already used by another site in this organisation.',
    erfNumber: 'Site ERF number',
    erfNumberPlaceholder: 'Site ERF number (eg. ERF_123)',
    erfNumberExists: 'A site with this ERF number already exists in this project.',
    siteDates: 'Planned commencement & completion',
    siteDatesPlaceholder: 'Select a date range',
    startDate: 'Commencement',
    endDate: 'Completion',
    datePlaceholder: 'Select a date',
    endDateLocked:
      'Once orders have been placed on this site, only someone who manages its draw schedule can change the completion date.',
    clientType: {
      company: 'Company',
      private: 'Private client',
      none: 'No client',
    },
    companyName: 'Company name',
    companyVat: 'Company VAT no.',
    clientName: 'Client name',
    clientContactNumber: 'Client contact no.',
    clientEmail: 'Client email',
    deliverySameAsSite: 'Delivery address is the same as the site address',
    contractType: {
      fixedCost: {
        label: 'Fixed cost',
        description: 'BOQ line items have no markup set, contract is set at an agreed upon value.',
      },
      costPlus: {
        label: 'Cost plus / Remeasurable',
        description:
          'BOQ items have a mark up percentage, you can alter individual markups within your BOQ claim view.',
      },
      noContract: {
        label: 'No contract',
        description: 'This site does not contain a contract. No markup is added.',
      },
    },
    contractAmount: 'Amount',
    markupPercentage: 'Percentage',
    bankFunded: {
      label: 'Bank funding',
      description: 'The site is funded by a loan from a bank.',
    },
    selfFunded: {
      label: 'Self funding',
      description: 'The site is funded from your own capital.',
    },
    bank: 'Bank',
    loanAmount: 'Loan amount',
    loanAccountNumber: 'Loan account number',
    selfFundingAmount: 'Self funding amount',
    totalFunding: 'Total funding',
  },
  validation: {
    fundingSourceRequired: 'Select at least one funding source.',
  },
};
